/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logo from 'assets/images/logo/logoXpoPRO.png';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';

// Two types classroom view or webinar view, changes background and chat component
export default class SessionItemView2 extends Component {
  render() {
    const { url } = this.props.match;
    console.log(url);
    return (
      <div className="sessionItemView">

        <div className="gradient" />
        <div className="bg" />

        <div className="sessionItemHolder">

          <div className="video">
            {url === '/main/breakout-sessions/class/30 minutes' &&
              <video
                src="https://front.travpromobile.com/614/TravPRO TRAINING [Advisors].mp4"
                autoPlay
                preload="auto"
                height="100%"
                width="100%"
                controls
              >
                <track kind="captions" />
              </video>
            }
            {url === '/main/breakout-sessions/class/23 minutes' &&
            <video
              src="https://front.travpromobile.com/614/bigmarker-recording.mp4"
              autoPlay
              preload="auto"
              height="100%"
              width="100%"
              controls
            >
              <track kind="captions" />
            </video>
          }
            {url === '/main/breakout-sessions/class/25 minutes' &&
            <video
              src="https://front.travpromobile.com/614/zoom_0.mp4"
              autoPlay
              preload="auto"
              height="100%"
              width="100%"
              controls
            >
              <track kind="captions" />
            </video>
        }
            <div className="title">
              <span>How to sell in Corona times</span>
              <div className="subtitle">
                In the video are 5 tips for creating a simple system that will optimize your sales conversions – but before we launch into this, here is a bit more detail on conversion rates and cost of sale in travel.
              </div>
            </div>
          </div>

          <div className="speakerHolder">
            <img className="user__image" alt="user" src="https://front.travpromobile.com/614/0.jpg" />
            <div className="user">Jonathan Cooper</div>
            <div className="sub">CEO / Founder TravPRO Mobile & ChannelPRO Mobile</div>
            <hr />
            <div className="socials">
              <span>Connect with me:</span>
              <div className="social__items">
                <a href="mailto:jcooper@travpromobile.com">
                  <FontAwesomeIcon icon={['fas', 'envelope']} />
                </a>
                <a href="https://www.linkedin.com/in/jlcooper522/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={['fab', 'linkedin']} />
                </a>
              </div>
            </div>
          </div>

        </div>
        <div className="bottom__bar" />
      </div>
    );
  }
}


SessionItemView2.propTypes = {
  match: PropTypes.shape().isRequired,
};
